import { Component, OnInit } from '@angular/core';
import { DiscordEmbed, DiscordEmoji } from '../embed-builder/embed.model';
import { EmbedService } from '../../services/embed.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-embed-preview',
  templateUrl: './embed-preview.component.html',
  styleUrls: ['./embed-preview.component.css'],
})
export class EmbedPreviewComponent implements OnInit {
  embed: DiscordEmbed;
  emojis: DiscordEmoji[];
  signupTemplateUseButtons: boolean = false;
  chunkedEmojis: DiscordEmoji[][] = []; // Cache for chunked emojis
  private subscriptions = new Subscription(); // Manage subscriptions

  constructor(
    public embedService: EmbedService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.embedService.currentEmbed.subscribe((embed) => {
        this.embed = embed;
      })
    );

    this.subscriptions.add(
      this.embedService.currentSignupTemplateUseButtons.subscribe(
        (useButtons) => {
          this.signupTemplateUseButtons = useButtons;
          this.updateChunkedEmojis();
        }
      )
    );

    this.subscriptions.add(
      this.embedService.currentEmojis.subscribe((emojis) => {
        this.emojis = emojis;
        this.updateChunkedEmojis();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // Clean up all subscriptions
  }

  updateChunkedEmojis(): void {
    if (this.signupTemplateUseButtons && this.emojis) {
      this.chunkedEmojis = this.chunk(this.emojis, 5);
    } else {
      this.chunkedEmojis = [];
    }
  }

  isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  sanitizeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  /**
   * Groups emojis into rows with a given maximum number per row
   * @param emojis Array of emojis
   * @param maxPerRow Maximum emojis per row
   * @returns Array of rows (each row is an array of emojis)
   */
  groupEmojisIntoRows(
    emojis: DiscordEmoji[],
    maxPerRow: number
  ): DiscordEmoji[][] {
    const rows: DiscordEmoji[][] = [];
    for (let i = 0; i < emojis.length; i += maxPerRow) {
      rows.push(emojis.slice(i, i + maxPerRow));
    }
    return rows;
  }

  chunk(array: any[], size: number): any[][] {
    const chunks = [];
    array = array.filter(
      (emoji: { type: string }) =>
        emoji.type === 'role' || emoji.type === 'remove'
    );
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  get hasStatusOrSpecialEmojis(): boolean {
    return this.emojis?.some((emoji) => emoji.type !== 'role' && emoji.type !== 'remove') || false;
  }
}
